import React, { useEffect } from 'react'
import pushGtmEvent from 'utils/gtm'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import injectTranslate from 'i18n/hoc/injectTranslate'
import InfoBlock from 'pages/ProHomePage/Content/InfoBlock'
import PricingBlock from 'pages/ProHomePage/Content/PricingBlock'
import PartnerBlock from 'pages/ProHomePage/Content/PartnerBlock'
import AppInfoBlock from 'pages/ProHomePage/Content/AppInfoBlock'
import ProInfoBlock from 'pages/ProHomePage/Content/ProInfoBlock'
import OurProBlock from 'pages/ProHomePage/Content/OurProBlock'
import SeeAnswersBlock from 'pages/ProHomePage/Content/SeeAnswersBlock'
import StepToBecomeProBlock from 'pages/ProHomePage/Content/StepToBecomeProBlock'
import PropTypes from 'prop-types'

const App = ({ translate }) => {
  useEffect(() => {
    pushGtmEvent({
      event: 'LoadNewProHomePage',
      category: 'NewProHomePage',
    })
  }, [])

  return (
    <>
      <InfoBlock />
      <PricingBlock
        headlineText={translate('propage.block2.title')}
        columns={[
          {
            image: '8',
            alt: translate('alt.pro.piggy-bank'),
            text: translate('propage.block2.sub1.text'),
            title: translate('propage.block2.sub1.title'),
          },
          {
            image: '9',
            alt: translate('alt.pro.wallet'),
            text: translate('propage.block2.sub2.text'),
            title: translate('propage.block2.sub2.title'),
          },
          {
            image: '10',
            alt: translate('alt.pro.calendar-map'),
            text: translate('propage.block2.sub3.text'),
            title: translate('propage.block2.sub3.title'),
          },
          {
            image: '11',
            alt: translate('alt.pro.folder'),
            text: translate('propage.block2.sub4.text'),
            title: translate('propage.block2.sub4.title'),
          },
        ]}
        endlineText={translate('propage.block2.text')}
        endlineLinkText={translate('propage.block2.link')}
        endlineLink="/"
      />
      <PartnerBlock />
      <Container hasBackgroundGradient>
        <AppInfoBlock />
        <ProInfoBlock />
      </Container>
      <Container>
        <OurProBlock
          title={translate('propage.block6.title')}
          pros={[
            {
              href: 'https://annuaire.quotatis.fr/artisan/s-confort-3PRIFmklwGaObHZqbccVGP',
              image: 'eric',
              name: translate('propage.block6.sub1.name'),
              job: translate('propage.block6.sub1.job'),
              city: translate('propage.block6.sub1.city'),
              testimony: translate('propage.block6.sub1.testimony'),
            },
            {
              href: 'https://annuaire.quotatis.fr/artisan/wakenson-menuiseries-6FiZuyAVtL2qPaeESqo4th',
              image: 'wakenson',
              name: translate('propage.block6.sub2.name'),
              job: translate('propage.block6.sub2.job'),
              city: translate('propage.block6.sub2.city'),
              testimony: translate('propage.block6.sub2.testimony'),
            },
            {
              href: 'https://annuaire.quotatis.fr/artisan/dim-plomb-chauff-467jWOyqCn8x5ivPc9hWzW',
              image: 'dimitri',
              name: translate('propage.block6.sub3.name'),
              job: translate('propage.block6.sub3.job'),
              city: translate('propage.block6.sub3.city'),
              testimony: translate('propage.block6.sub3.testimony'),
            },
          ]}
        />
        <SeeAnswersBlock />
        <StepToBecomeProBlock />
      </Container>
    </>
  )
}

App.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(App)
